import { createNotImplementedMethod } from '../utils';
var NotImplementedMealPrepRepository = /** @class */ (function () {
    function NotImplementedMealPrepRepository() {
        this.getMealPrepPlan = createNotImplementedMethod();
    }
    return NotImplementedMealPrepRepository;
}());
export { NotImplementedMealPrepRepository };
